import React from "react";
import { Button } from "reactstrap";
import i18n from "i18n";

function BtnCustom(props) {
  const {
    isLoading,
    children,
    className = "mb-3",
    size = "lg",
    type = "submit",
    color = "primary",
    submittingText = i18n.t("common:actions.submitting"),
    disabled = isLoading,
    ...rest
  } = props;
  return (
    <Button
      className={className}
      color={color}
      size={size}
      type={type}
      disabled={disabled}
      {...rest}
    >
      {isLoading ? (
        <div className="d-flex align-items-center justify-content-center">
          <span className="spinner-border spinner-border-sm mr-2"></span>
          <span>{submittingText}</span>
        </div>
      ) : (
        children
      )}
    </Button>
  );
}

export default BtnCustom;
